import api from "./api";

const pagamentosService = {
  uploadBoleto: async (solicitacaoId, arquivo, descricao) => {
    try {
      const formData = new FormData();
      formData.append("solicitacaoId", solicitacaoId);
      if (descricao) formData.append("descricao", descricao);
      formData.append("arquivo", arquivo);

      const response = await api.post(`Pagamento/Boleto`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: "Erro ao enviar boleto" };
    }
  },

  listarBoletosDaSolicitacao: async (solicitacaoId) => {
    try {
      const response = await api.get(
        `Pagamento/Boleto/solicitacao/${solicitacaoId}`,
      );
      return response.data.data || [];
    } catch (error) {
      throw error.response?.data || { message: "Erro ao listar boletos" };
    }
  },

  getBoletoById: async (id) => {
    try {
      const response = await api.get(`Pagamento/Boleto/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: "Erro ao obter boleto" };
    }
  },

  uploadComprovante: async (pdfBoletoId, solicitacaoId, arquivo) => {
    try {
      const formData = new FormData();
      formData.append("pdfBoletoId", pdfBoletoId);
      formData.append("solicitacaoId", solicitacaoId);
      formData.append("arquivo", arquivo);

      const response = await api.post(`Pagamento/Comprovante`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: "Erro ao enviar comprovante" };
    }
  },

  getComprovanteByBoletoId: async (boletoId) => {
    try {
      const response = await api.get(`Pagamento/Comprovante/boleto/${boletoId}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) return null;
      throw error.response?.data || { message: "Erro ao obter comprovante" };
    }
  },

  getComprovanteById: async (id) => {
    try {
      const response = await api.get(`Pagamento/Comprovante/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: "Erro ao obter comprovante" };
    }
  },
};

export default pagamentosService;
